import { useEffect } from "react";
import { NavLink } from "react-router-dom";

const HeroSection = () => {
  useEffect(() => {
    const video = document.getElementById("background-video");
    if (video) {
      video.playbackRate = 0.75;
      video.play().catch(err => {
        // handle autoplay block (optional)
        console.log("Autoplay failed: ", err);
      });
    }
  }, []);

  return (
    <div className="th-hero-wrapper hero-5" id="hero">
      {/* Local Video Background */}
      <div className="video-background">
        <video
          id="background-video"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"  // help browser preload only once
          className="background-video"
        >
          <source src="/videos/background.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      <div className="video-overlay"></div>

      <div className="hero-inner" style={{ background: "transparent" }}>
        <div className="container th-container5">
          <div
            className="hero-style5"
            style={{
              maxWidth: "100%",
              paddingTop: "80px",
              paddingBottom: "50px",
            }}
          >
            <h1 className="hero-title text-white" style={{ fontSize: "3rem" }}>
              Warrgyiz Morsch : <br /> Complete IT Solutions for Your Business
            </h1>
            <p className="hero-text text-white">
              At WarrgyizMorsch, we are experts in providing end-to-end IT solutions that are specifically designed to cater to your business requirements. From robust web development that makes your online presence robust and scalable, to strategic digital marketing that inspires measurable growth - we provide it all at one place. Our expert professionals work towards empowering businesses to excel in a competitive digital world with cutting-edge technology, quick response support, and up-to-the-mark service. Join forces with WarrgyizMorsch and explore the entire potential of your brand through innovative IT solutions.
            </p>
            <div className="btn-group mt-35">
              <NavLink to="/contact-us" className="th-btn style6 style-radius">
                Contact Us
              </NavLink>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .th-hero-wrapper.hero-5 {
          position: relative;
          width: 100%;
          height: auto;
          overflow: hidden;
          display: flex;
          flex-direction: column;
        }

        @media (min-width: 1024px) {
          .th-hero-wrapper.hero-5 {
            height: 100vh;
            max-height: 750px;
            justify-content: flex-end;
          }
        }

        .video-background {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          z-index: 0;
          overflow: hidden;
        }

        .background-video {
          position: absolute;
          top: 50%;
          left: 50%;
          width: auto;
          height: 100%;
          min-width: 100%;
          min-height: 100%;
          transform: translate(-50%, -50%);
          object-fit: cover;
        }

        .video-overlay {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          background-color: rgba(0, 0, 0, 0.4);
          z-index: 1;
          pointer-events: none;
        }

        .hero-inner {
          position: relative;
          z-index: 2;
          pointer-events: none;
        }

        .hero-inner * {
          pointer-events: auto;
        }
      `}</style>
    </div>
  );
};

export default HeroSection;
